import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientNotesComponent } from './client-notes.component';

const routes: Routes = [ { path: '', component: ClientNotesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientNotesRoutingModule { }
